import { C1_FloorFinish, RoomType, type RoomTemplate } from "../types/C1_ModelTypes";

export type FloorLevel = "K" | "EG" | "OG" | "DG" | "DACH";

export const PerferedRoom: Record<FloorLevel, string[]> = {
  K: ["HR", "HAR", "GAR", "F", "T", "A", "H", "WK", "HWR"],
  EG: ["W", "E", "K", "F", "T", "GWC", "AZ", "GZ", "A", "FGAR", "CP", "TER", "BAL", "GART", "EIN", "GEIN"],
  OG: ["S", "S1", "S2", "F", "T", "B", "AZ", "GZ", "A"],
  DG: ["ST", "F", "T", "S", "B", "AZ", "GZ", "A", "DTER", "SGU"],
  DACH: ["DACH"],
};

export function floorLevelFromNumber(level: number): FloorLevel {
  if (level < 0) return "K";
  if (level === 0) return "EG";
  if (level === 1) return "OG";
  if (level === 2) return "DG";
  return "DACH";
}

const templates: Array<RoomTemplate> = [
  {
    key: "W",
    type: RoomType.Living,
    defaultWidth: 4,
    defaultHeight: 5,
    description: {
      de: "Wohnen",
      en: "Living",
    },
  },
  {
    key: "E",
    type: RoomType.Dining,
    defaultWidth: 3.5,
    defaultHeight: 4,
    description: {
      de: "Essen",
      en: "Dining room",
    },
  },
  {
    key: "K",
    type: RoomType.Kitchen,
    defaultWidth: 3.5,
    defaultHeight: 4,
    description: {
      de: "Küche",
      en: "Kitchen",
    },
  },
  {
    key: "F",
    type: RoomType.Hallway,
    defaultWidth: 1.5,
    defaultHeight: 4,
    description: {
      de: "Flur",
      en: "Hallway",
    },
  },
  {
    key: "T",
    type: RoomType.Staircase,
    defaultWidth: 2,
    defaultHeight: 4,
    description: {
      de: "Treppe",
      en: "Staircase",
    },
  },
  {
    key: "GWC",
    type: RoomType.GuestToilet,
    defaultWidth: 1.5,
    defaultHeight: 2,
    description: {
      de: "Gäste-WC",
      en: "Guest toilet",
    },
  },
  {
    key: "HWR",
    type: RoomType.Utility,
    defaultWidth: 2.5,
    defaultHeight: 3,
    description: {
      de: "Hauswirtschaftsraum",
      en: "Utility room",
    },
  },
  {
    key: "AZ",
    type: RoomType.Office,
    defaultWidth: 3,
    defaultHeight: 3.5,
    description: {
      de: "Arbeiten",
      en: "Home office",
    },
  },
  {
    key: "B",
    type: RoomType.Bathroom,
    defaultWidth: 3,
    defaultHeight: 3.5,
    description: {
      de: "Bad",
      en: "Bathroom",
    },
  },
  {
    key: "S",
    type: RoomType.Bedroom,
    defaultWidth: 4,
    defaultHeight: 4,
    description: {
      de: "Schlafen",
      en: "Bedroom",
    },
  },
  {
    key: "S1",
    type: RoomType.Child,
    defaultWidth: 3,
    defaultHeight: 3.5,
    description: {
      de: "Kind 1",
      en: "Child 1",
    },
  },
  {
    key: "S2",
    type: RoomType.Child,
    defaultWidth: 3,
    defaultHeight: 3.5,
    description: {
      de: "Kind 2",
      en: "Child 2",
    },
  },
  {
    key: "GZ",
    type: RoomType.Bedroom,
    defaultWidth: 3.5,
    defaultHeight: 4,
    description: {
      de: "Gästezimmer",
      en: "Guest room",
    },
  },
  {
    key: "A",
    type: RoomType.Storage,
    defaultWidth: 2,
    defaultHeight: 2,
    description: {
      de: "Abstellraum",
      en: "Storage room",
    },
  },
  {
    key: "H",
    type: RoomType.Hobby,
    defaultWidth: 4,
    defaultHeight: 4,
    description: {
      de: "Hobbyraum",
      en: "Hobby room",
    },
  },
  {
    key: "WK",
    type: RoomType.Laundry,
    defaultWidth: 2.5,
    defaultHeight: 3,
    description: {
      de: "Waschküche",
      en: "Laundry room",
    },
  },
  {
    key: "ST",
    type: RoomType.Hobby,
    defaultWidth: 5,
    defaultHeight: 5,
    description: {
      de: "Studio",
      en: "Studio",
    },
  },
  {
    key: "HR",
    type: RoomType.HeatingRoom,
    defaultWidth: 3,
    defaultHeight: 3,
    description: { de: "Heizungsraum", en: "Boiler room" },
  },
  {
    key: "HAR",
    type: RoomType.UtilityConnectionRoom,
    defaultWidth: 2.5,
    defaultHeight: 3,
    description: { de: "Hausanschlussraum", en: "Utility connection room" },
  },
  {
    key: "GAR",
    type: RoomType.Garage,
    defaultWidth: 3.5,
    defaultHeight: 6,
    description: { de: "Garage", en: "Garage" },
  },
  {
    key: "FGAR",
    type: RoomType.DetachedGarage,
    defaultWidth: 3.5,
    defaultHeight: 6,
    description: { de: "Garage freistehend", en: "Detached garage" },
  },
  {
    key: "CP",
    type: RoomType.Carport,
    defaultWidth: 3.5,
    defaultHeight: 6,
    description: { de: "Carport", en: "Carport" },
  },
  {
    key: "TER",
    type: RoomType.Terrace,
    defaultWidth: 4,
    defaultHeight: 3,
    description: { de: "Terrasse", en: "Terrace" },
  },
  {
    key: "BAL",
    type: RoomType.Balcony,
    defaultWidth: 3,
    defaultHeight: 1.5,
    description: { de: "Balkon", en: "Balcony" },
  },
  {
    key: "GART",
    type: RoomType.Garden,
    defaultWidth: 6,
    defaultHeight: 5,
    description: { de: "Garten", en: "Garden" },
  },
  {
    key: "EIN",
    type: RoomType.Entrance,
    defaultWidth: 2,
    defaultHeight: 2,
    description: { de: "Eingang", en: "Entrance" },
  },
  {
    key: "GEIN",
    type: RoomType.GarageDriveway,
    defaultWidth: 3.5,
    defaultHeight: 5,
    description: { de: "Garagen-Einfahrt", en: "Garage driveway" },
  },
  {
    key: "DTER",
    type: RoomType.RoofTerrace,
    defaultWidth: 4,
    defaultHeight: 3,
    description: { de: "Dachterrasse", en: "Roof terrace" },
  },
  {
    key: "SGU",
    type: RoomType.PenthousePerimeter,
    defaultWidth: 1,
    defaultHeight: 1,
    description: { de: "Staffelgeschoss-Außen", en: "Penthouse exterior" },
  },
  {
    key: "DACH",
    type: RoomType.Roof,
    defaultWidth: 8,
    defaultHeight: 10,
    description: { de: "Dach", en: "Roof" },
  },
];

export const C1_DEFAULT_FLOOR_FINISH_BY_ROOM_TYPE: Record<RoomType, C1_FloorFinish> = {
  [RoomType.Living]: C1_FloorFinish.Parquet1,
  [RoomType.Dining]: C1_FloorFinish.Parquet1,
  [RoomType.Office]: C1_FloorFinish.Parquet1,
  [RoomType.Child]: C1_FloorFinish.Parquet1,
  [RoomType.Bedroom]: C1_FloorFinish.Parquet1,
  [RoomType.Hobby]: C1_FloorFinish.Parquet1,
  [RoomType.Hallway]: C1_FloorFinish.Tiles1,
  [RoomType.Staircase]: C1_FloorFinish.Tiles1,
  [RoomType.Entrance]: C1_FloorFinish.Tiles1,
  [RoomType.Kitchen]: C1_FloorFinish.Tiles2,
  [RoomType.Bathroom]: C1_FloorFinish.Tiles2,
  [RoomType.GuestToilet]: C1_FloorFinish.Tiles2,
  [RoomType.Utility]: C1_FloorFinish.General1,
  [RoomType.Storage]: C1_FloorFinish.General1,
  [RoomType.Laundry]: C1_FloorFinish.General1,
  [RoomType.HeatingRoom]: C1_FloorFinish.General1,
  [RoomType.UtilityConnectionRoom]: C1_FloorFinish.General1,
  [RoomType.Garage]: C1_FloorFinish.General1,
  [RoomType.DetachedGarage]: C1_FloorFinish.General1,
  [RoomType.Carport]: C1_FloorFinish.Paving1,
  [RoomType.Other]: C1_FloorFinish.General1,
  [RoomType.Garden]: C1_FloorFinish.Grass,
  [RoomType.Terrace]: C1_FloorFinish.Terrace,
  [RoomType.Balcony]: C1_FloorFinish.Terrace,
  [RoomType.RoofTerrace]: C1_FloorFinish.Terrace,
  [RoomType.PenthousePerimeter]: C1_FloorFinish.Terrace,
  [RoomType.GarageDriveway]: C1_FloorFinish.Paving1,
  [RoomType.Roof]: C1_FloorFinish.None,
};

export function defaultFloorFinishForRoomType(roomType: RoomType): C1_FloorFinish {
  return C1_DEFAULT_FLOOR_FINISH_BY_ROOM_TYPE[roomType];
}

const data: Array<RoomTemplate> = templates.map((template) => ({
  ...template,
  defaultFloorFinish: defaultFloorFinishForRoomType(template.type),
}));

export function getPreferredRoomTemplates(level: number): RoomTemplate[] {
  const preferredKeys = PerferedRoom[floorLevelFromNumber(level)];
  return preferredKeys
    .map((key) => data.find((template) => template.key === key))
    .filter((template): template is RoomTemplate => template !== undefined);
}

export function getOtherRoomTemplates(level: number): RoomTemplate[] {
  const preferredKeys = PerferedRoom[floorLevelFromNumber(level)];
  return data.filter((template) => !preferredKeys.includes(template.key));
}

export default data;
